const title = `My Intentional Motivational Morning Routine (IMMR)`;
const date = `November 2022`;
export const immrPost = {
  title: title,
  date: date,
  url: 'posts/IMMR',
  body: `# ${title}

<sub>${date}</sub>

<span class="post-first-character">I</span>

would like to introduce my Intentional Motivational Morning Routine (IMMR), my ultimate productivity improver. See attached PDF below. Completing this in the morning helps sort out your thoughts, get you motivated by clarifying what you're trying to accomplish, and it's especially helpful when you may or may not realize that you're struggling with unclear goals or losing intensity when grinding on a long project. When burnt out, it's challenging to maintain a positive outlook and continue moving forward. IMMR can help bring clarity and motivation to your mornings.

Acknowledging how you're feeling and thinking of how you want to respond to your emotions is also an essential aspect of IMMR. Mindset is critical to your performance, and you'll perform best when you're in a good mood. In fact, I often hear top esports players say that working on their mindset helped them become a better player. Being intentional means reflecting on why you do the things you do, and this helps bring more meaning to your life and prevent you from feeling like giving up. IMMR can help build your life around your core beliefs and prioritize what is truly important to you.

Another objective of IMMR is to help prioritize, visualize, and deeply consider your goals. You'll also feel and perform better by practicing appreciation, reflecting on your thoughts, and exercising. Scheduling your day or week can also help you stay on track. By following an IMMR, you can set yourself up for success each day and live a more intentional, productive, and fulfilling life. Start your day off right and reap the benefits of a successful morning routine!
<span class="post-trailing-square">■</span>

<span>
  <a target="_blank" href="../images/IMMR.pdf">IMMR.pdf</a>
  |
  <a target="_blank" href="../images/IMMR.pptx">IMMR.pptx</a>
  |
  <a target="_blank" href="../images/IMMR.jpg">IMMR.jpg</a>
</span>

<br>
<br>

<img src="../images/IMMR.jpg" width="100%">

`};